import { render, staticRenderFns } from "./compact_code_dropdown.vue?vue&type=template&id=813c85f4&vue3"
import script from "./compact_code_dropdown.vue?vue&type=script&lang=js&vue3"
export * from "./compact_code_dropdown.vue?vue&type=script&lang=js&vue3"
import style0 from "./compact_code_dropdown.vue?vue&type=style&index=0&id=813c85f4&prod&lang=css&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports